import React, { useState } from "react";
import {
  Form,
  Button,
  Table,
  Container,
  Row,
  Col,
  Card
} from "react-bootstrap";
import {
  dummyIncomeCategories,
  dummyExpenseCategories,
  dummyPaymentMethods,
  dummyTransactions
} from "../data/dummyData";
import { Plus, Download } from "lucide-react";
import { Transaction } from "../../../types";
import { Link } from "react-router-dom";
import TooltipOption from "../../../core/common/tooltipOption";
import { all_routes } from "../../router/all_routes";

const IncomeExpenses = () => {
  const [type, setType] = useState<"income" | "expense">("income");
  const [category, setCategory] = useState("");
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState("");
  const [description, setDescription] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [transactions, setTransactions] =
    useState<Transaction[]>(dummyTransactions);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const selectedCategory =
      type === "income"
        ? dummyIncomeCategories.find((c) => c.name === category)
        : dummyExpenseCategories.find((c) => c.name === category);

    if (!selectedCategory) return;

    const newTransaction: Transaction = {
      id: Math.random().toString(),
      type,
      category,
      amount: parseFloat(amount),
      date,
      description,
      paymentMethod,
      transactionType: selectedCategory.transactionType
    };

    setTransactions([newTransaction, ...transactions]);

    // Clear form
    setCategory("");
    setAmount("");
    setDate("");
    setDescription("");
    setPaymentMethod("");
  };

  const categories =
    type === "income" ? dummyIncomeCategories : dummyExpenseCategories;
  const filteredTransactions = transactions.filter((t) => t.type === type);

  const routes = all_routes;

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Add new Income and Expsenses</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Report</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                 New Icome & Expenses
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <TooltipOption />
          </div>
        </div>
        <Container className="py-4">
          <h2 className="mb-4">Income & Expenses</h2>

          <Row>
            <Col md={4}>
              <Card>
                <Card.Header>
                  Add {type === "income" ? "Income" : "Expense"}
                </Card.Header>
                <Card.Body>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>Type</Form.Label>
                      <Form.Select
                        value={type}
                        onChange={(e) =>
                          setType(e.target.value as "income" | "expense")
                        }
                      >
                        <option value="income">Income</option>
                        <option value="expense">Expense</option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Category</Form.Label>
                      <Form.Select
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        required
                      >
                        <option value="">Select Category</option>
                        {categories.map((cat) => (
                          <option key={cat.id} value={cat.name}>
                            {cat.name} ({cat.type} - {cat.transactionType})
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Amount</Form.Label>
                      <Form.Control
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Date</Form.Label>
                      <Form.Control
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Payment Method</Form.Label>
                      <Form.Select
                        value={paymentMethod}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        required
                      >
                        <option value="">Select Payment Method</option>
                        {dummyPaymentMethods.map((method) => (
                          <option key={method.id} value={method.name}>
                            {method.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    <Button type="submit" variant="primary">
                      <Plus size={16} className="me-2" />
                      Add {type === "income" ? "Income" : "Expense"}
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>

            {/* <Col md={8}>
              <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                  <span>
                    {type === "income" ? "Income" : "Expense"} Transactions
                  </span>
                  <Button variant="outline-primary" size="sm">
                    <Download size={16} className="me-2" />
                    Download
                  </Button>
                </Card.Header>
                <Card.Body>
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Category</th>
                        <th>Type</th>
                        <th>Transaction Type</th>
                        <th>Description</th>
                        <th>Amount</th>
                        <th>Payment Method</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredTransactions.map((transaction) => {
                        const category =
                          type === "income"
                            ? dummyIncomeCategories.find(
                                (c) => c.name === transaction.category
                              )
                            : dummyExpenseCategories.find(
                                (c) => c.name === transaction.category
                              );

                        return (
                          <tr key={transaction.id}>
                            <td>{transaction.date}</td>
                            <td>{transaction.category}</td>
                            <td>{category?.type || "-"}</td>
                            <td>{transaction.transactionType}</td>
                            <td>{transaction.description}</td>
                            <td
                              className={
                                transaction.type === "income"
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {transaction.amount.toLocaleString()}
                            </td>
                            <td>{transaction.paymentMethod}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col> */}
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default IncomeExpenses;
